import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = Record<string, never>;

export const schemaLoanRequestResolver_GetIdsWithAttribution = z.array(z.string());

export type SchemaLoanRequestResolver_GetIdsWithAttribution = z.infer<
    typeof schemaLoanRequestResolver_GetIdsWithAttribution
>;

export type LoanRequestResolver_GetIdsWithAttribution = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetIdsWithAttribution
>;
